import { PARTNER_BRAND, PARTNER_BRAND_HOVER } from '../../Partner/partnerDashboardTheme';

export const COMPANY_INFO_FIELD_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    bgcolor: 'background.paper',
    fontSize: '0.875rem',
    color: 'text.primary',
    '& fieldset': {
      borderColor: 'divider',
      borderWidth: 1.5,
    },
    '&:hover fieldset': {
      borderColor: 'text.disabled',
    },
    '&.Mui-focused fieldset': {
      borderColor: PARTNER_BRAND,
      borderWidth: 1.5,
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'text.disabled',
    opacity: 1,
  },
  '& textarea': {
    overflowY: 'auto !important',
    resize: 'none',
  },
};

export const companyInfoLabelSx = {
  fontWeight: 700,
  fontSize: '0.84375rem',
  color: 'text.primary',
  mb: 1,
  display: 'block',
};

export const companyInfoRequiredMarkSx = {
  color: PARTNER_BRAND,
  ml: 0.35,
};

export const companyInfoPrimaryButtonSx = {
  textTransform: 'none',
  borderRadius: '22px',
  fontWeight: 700,
  fontSize: '0.84375rem',
  bgcolor: PARTNER_BRAND,
  boxShadow: 'none',
  px: 3.25,
  py: 1.5,
  minWidth: 0,
  '&:hover': {
    bgcolor: PARTNER_BRAND_HOVER,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    color: 'primary.contrastText',
  },
};

export const companyInfoUploadButtonSx = {
  textTransform: 'none',
  borderRadius: '10px',
  fontWeight: 700,
  fontSize: '0.8125rem',
  bgcolor: PARTNER_BRAND,
  color: 'primary.contrastText',
  boxShadow: 'none',
  px: 2.5,
  py: 1.35,
  minWidth: 140,
  justifyContent: 'flex-start',
  '&:hover': {
    bgcolor: PARTNER_BRAND_HOVER,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    bgcolor: 'action.hover',
    color: 'text.disabled',
  },
};

export const companyInfoOutlinedButtonSx = {
  textTransform: 'none',
  borderRadius: '10px',
  fontWeight: 700,
  fontSize: '0.8125rem',
  border: '1.5px solid',
  borderColor: PARTNER_BRAND,
  color: PARTNER_BRAND,
  px: 2.5,
  py: 1.35,
  minWidth: 140,
  justifyContent: 'flex-start',
  bgcolor: 'background.paper',
  '&:hover': {
    borderColor: PARTNER_BRAND,
    bgcolor: 'action.hover',
  },
};
